import { Component, inject, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { MatDialogConfig, MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ViewerConfigurationService } from "../../viewer-components/services/viewer-configuration.service";
import { GeoJSONDatabaseService } from "../../viewer-components/services/internal-services/geojson-database.service";
import { XyzLayerResultsDialogComponent } from "./xyz-layer-results-dialog.component";
import { PhoenixViewerService } from "../../viewer-components/services/internal-services/viewer-services/phoenix-viewer.service";
import { Viewerlayer } from "../../viewer-components/model/viewerlayer";
import { BaseViewerService } from "../../viewer-components/services/internal-services/viewer-services/base-viewer.service";
import { IDialogData } from "../../viewer-components/interfaces/i-dialog-data";
import {
  GoogleAnalyticsConstantsCategory,
  GoogleAnalyticsConstantsEvents,
} from "../../viewer-components/../shared/model/google-analytics-constants";
import { GoogleAnalyticsService } from "../../shared/services/google-analytics.service";
import { VIEWER_SERVICE } from "../../viewer-components/services/internal-services/viewer-services/inject-base-viewer.service";

@Component({
  selector: "phoenix-xyz-layer-results-dialog-component",
  templateUrl: "./xyz-layer-results-dialog.component.html",
  styleUrls: ["./xyz-layer-results-dialog.component.scss"],
  providers: [MatDialogConfig],
  standalone: false,
})
export class PhoenixXyzLayerResultsDialogComponent extends XyzLayerResultsDialogComponent {
  constructor(
    http: HttpClient,
    viewerConfigurationService: ViewerConfigurationService,
    geoJSONDatabaseService: GeoJSONDatabaseService,
    googleAnalyticsService: GoogleAnalyticsService,
    matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: IDialogData,
    @Inject(VIEWER_SERVICE) public viewerService: BaseViewerService,
  ) {
    super(http, viewerConfigurationService, geoJSONDatabaseService, googleAnalyticsService, matDialog, data);
  }

  saveLayer(layer: Viewerlayer) {
    this.geoJSONDatabaseService.saveLayer(layer).subscribe(() => {
      this.viewerService.addUserLayer(layer);
      this.viewerService.updateUserOrder(this.viewerService.getUserLayers());
    });
    this.googleAnalyticsService.setGoogleAnalyticsEvent(
      GoogleAnalyticsConstantsEvents.ADD_DATA_XYZ,
      GoogleAnalyticsConstantsCategory.LEFT_TOOLBAR,
      true,
    );
  }
}
